import { Stack, StackProps } from '@mui/material'
import { C1Card } from 'components/core/card/C1Card'
import { FC, ReactNode } from 'react'

interface LoginCardProps extends StackProps {
    children: ReactNode
}

export const LoginCard: FC<LoginCardProps> = ({ children, ...props }) => (
    <C1Card
        sx={{
            p: 5,
            maxWidth: '500px',
            mb: 0,
            '@media (max-width: 400px)': {
                padding: 4,
                mx: 1,
            },
            ...props.sx,
        }}
    >
        <Stack spacing={4} {...props} sx={undefined}>
            {children}
        </Stack>
    </C1Card>
)
